import app from "flarum/forum/app";
import Page from "flarum/common/components/Page";
import listItems from "flarum/common/helpers/listItems";
import AffixedSidebar from "flarum/forum/components/AffixedSidebar";
import ItemList from "flarum/common/utils/ItemList";
import SelectDropdown from "flarum/common/components/SelectDropdown";
import LinkButton from "flarum/common/components/LinkButton";

export default class RoundPage extends Page {
  view(vnode: any) {
    return <div className="container">
      <div className="sideNavContainer">
        <AffixedSidebar>
          <nav className="sideNav UserPage-nav">
            <ul>{listItems(this.sidebarItems().toArray())}</ul>
          </nav>
        </AffixedSidebar>
        <div className="sideNavOffset UserPage-content">{this.content()}</div>
      </div>
    </div>;
  }

  sidebarItems() {
    const items = new ItemList();

    items.add(
      'nav',
      <SelectDropdown className="App-titleControl" buttonClassName="Button">
        {this.navItems().toArray()}
      </SelectDropdown>
    );

    return items;
  }

  navItems() {
    const items = new ItemList();

    items.add("zs-rounds", <LinkButton href={app.route("server.rounds")} icon="fas fa-biohazard">
      {app.translator.trans("rhodes-island.forum.rounds.zs_title")}
    </LinkButton>)

    items.add("scp-rounds", <LinkButton href={app.route("server.rounds.scp")} icon="fas fa-theater-masks">
      {app.translator.trans("rhodes-island.forum.rounds.scp_title")}
    </LinkButton>)

    return items;
  }

  content() {}
}
